// extracted by mini-css-extract-plugin
export var redoItem = "_kf-1";
export var redoTrigger = "_kf-0";